export const PLANNED_ROUTE_LINE_WIDTH = 6;
export const OVERLAY_ROUTE_LINE_WIDTH = 3;
export const DRIVEN_ROUTE_STROKE = '#FF6D00';

export const ROUTE_SECTION_COLORS = [
  'rgba(0, 0, 255, 0.7)',
  'rgba(0, 128, 0, 0.7)',
  'rgba(255, 165, 0, 0.70)',
  'rgba(128, 0, 128, 0.70)',
  'rgba(9, 4, 70, 0.70)',
  'rgba(28, 93, 153, 0.70)',
  'rgba(0, 183, 145, 0.70)',
  'rgba(127, 184, 0, 0.70)',
  'rgba(0, 166, 237, 0.70)',
];
